var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import throttle from 'lodash/throttle';
var BootstrapService = /** @class */ (function () {
    function BootstrapService(InstanceConfigService, AuthService, NumbersStateService, PlansStateService, ipUserInfo, BalanceNotificationsService, LiveChat, AmplitudeService, ProfitwellService, WidgetService, StripeApiKeyInjector, LastStateService, ng2BootstrapService, $q, $state, Router) {
        this.InstanceConfigService = InstanceConfigService;
        this.AuthService = AuthService;
        this.NumbersStateService = NumbersStateService;
        this.PlansStateService = PlansStateService;
        this.ipUserInfo = ipUserInfo;
        this.BalanceNotificationsService = BalanceNotificationsService;
        this.LiveChat = LiveChat;
        this.AmplitudeService = AmplitudeService;
        this.ProfitwellService = ProfitwellService;
        this.WidgetService = WidgetService;
        this.StripeApiKeyInjector = StripeApiKeyInjector;
        this.$state = $state;
        this.LastStateService = LastStateService;
        this.ng2BootstrapService = ng2BootstrapService;
        this.router = Router;
        this.bootstrapCompeted = $q.defer();
    }
    BootstrapService.prototype.blockedState = function (StripeElementsProvider) {
        var _this = this;
        return this.initInstanceConfig(StripeElementsProvider)
            .then(function () { return _this.AuthService.checkUser(); })
            .then(function () { return _this.LiveChat.initUserInfo(_this.AuthService.currentUser()); })
            .then(function () { return _this.ipUserInfo.isReady(); })
            .then(function () { return _this.BalanceNotificationsService.notifyIfRechargeFailed(); })
            .then(function () {
            _this.AmplitudeService.setUser(_this.AuthService.currentUser());
            _this.AmplitudeService.logEvent('Panel: Blocked state');
            _this.bootstrapCompeted.resolve(true);
        });
    };
    BootstrapService.prototype.chooseAccountState = function () {
        this.AmplitudeService.logEvent('Panel: Choose account state');
        this.bootstrapCompeted.resolve(true);
    };
    BootstrapService.prototype.fullAppState = function (StripeElementsProvider) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.AuthService.checkUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, throttle(function () { return _this.channelsBootstrap(StripeElementsProvider); }, 1000)()];
                }
            });
        });
    };
    BootstrapService.prototype.channelsBootstrap = function (StripeElementsProvider) {
        var _this = this;
        return throttle(function () { return _this.initInstanceConfig(StripeElementsProvider)
            .then(function () { return _this.PlansStateService.checkPlan(); })
            .then(function () { return _this.LiveChat.initUserInfo(_this.AuthService.currentUser()); })
            .then(function () { return _this.NumbersStateService.fetchNumbersAndBlockingStatus(); })
            .then(function () { return _this.LastStateService.restoreLastState({ defaultStateToGo: 'app.dashboard' }); })
            .then(function () {
            _this.AmplitudeService.setUser(_this.AuthService.currentUser());
            _this.AmplitudeService.logEvent('Panel: Full app state');
            _this.ng2BootstrapService.boostrapComplete();
            return _this.bootstrapCompeted.resolve(true);
        })
            .catch(function (error) {
            if (error && error.redirectTo) {
                _this.AmplitudeService.logEvent('Panel: Cannot fully load app - redirect required', {
                    redirectTo: error.redirectTo,
                    type: error.type
                });
                // TODO: cannot remove the $state here yet; make it as a next step of cleanup
                console.log('error.redirectTo: ', error.redirectTo);
                _this.$state.go(error.redirectToState, {}, { reload: true });
                _this.router.navigateByUrl(error.redirectTo);
            }
            else {
                throw error;
            }
        }); }, 10000)();
    };
    BootstrapService.prototype.isBootstrapCompeted = function () {
        return this.bootstrapCompeted.promise;
    };
    BootstrapService.prototype.initInstanceConfig = function (StripeElementsProvider) {
        var _this = this;
        return this.InstanceConfigService.get().$promise
            .then(function (config) {
            _this.StripeApiKeyInjector.setStripePublishableApiKey(config.stripeApiKey);
            StripeElementsProvider.setAPIKey(config.stripeApiKey);
        });
    };
    BootstrapService.$inject = ['InstanceConfigService', 'AuthService', 'NumbersStateService', 'PlansStateService', 'ipUserInfo', 'BalanceNotificationsService', 'LiveChat', 'AmplitudeService', 'ProfitwellService', 'WidgetService', 'StripeApiKeyInjector', 'LastStateService', 'ng2BootstrapService', '$q', '$state', 'Router'];
    return BootstrapService;
}());
export default BootstrapService;
